import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for fetching ItemsForSale
export const fetchSponsor = createAsyncThunk('sponsor/fetchSponsor', async (sponsorId) => {
  const response = await fetch(`/api/sponsors/${sponsorId}`);
  const data = await response.json();
  return data;
});

const sponsorSlice = createSlice({
  name: 'sponsor',
  initialState: { sponsor: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSponsor.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSponsor.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.sponsor = action.payload;
      })
      .addCase(fetchSponsor.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default sponsorSlice.reducer;